import React from 'react'
import { hydrate } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { loadableReady } from '@loadable/component'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { forceHydration } from '@uswitch/ev-utils/helpers/env'

import App from './app'

const cache = createCache({ key: 'ev' })

loadableReady(() => {
  hydrate(
    <CacheProvider value={cache}>
      <BrowserRouter>
        <App initialState={window.__initialState__} />
      </BrowserRouter>
    </CacheProvider>,
    document.getElementById('app'),
  )
})

// Hot reloading doesnt work with selective hydration
if (module.hot && forceHydration) {
  module.hot.accept()
}

console.log('client-with-js')
